import { useState, useEffect } from "react";
import { Leaf } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedData = null;

async function fetchEcologi() {
  if (cachedData) return cachedData;
  try {
    const res = await fetch(`${API}/ecologi`);
    const data = await res.json();
    cachedData = data;
    return data;
  } catch {
    return { trees: 0, profile_url: "https://ecologi.com/candopayments" };
  }
}

export function useEcologi() {
  const [data, setData] = useState(cachedData || { trees: 0, profile_url: "https://ecologi.com/candopayments" });
  useEffect(() => {
    fetchEcologi().then(setData);
  }, []);  
  return data;
}

export function EcologiFooterBadge() {
  const data = useEcologi();
  if (!data.trees) return null;
  return (
    <a href={data.profile_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-green-900/60 hover:bg-green-900/80 border border-green-700/40 rounded-full px-4 py-2 transition-colors group" data-testid="ecologi-footer-badge">
      <Leaf size={14} className="text-green-400" />
      <span className="text-sm text-green-300 font-semibold group-hover:text-white transition-colors">{`${data.trees.toLocaleString()} trees planted`}</span>
    </a>
  );
}

export function EcologiStatCard() {
  const data = useEcologi();
  return (
    <div className="text-center" data-testid="ecologi-stat-card">
      <p className="text-3xl font-heading font-bold text-brand-aqua">{data.trees > 0 ? data.trees.toLocaleString() : "..."}</p>
      <p className="text-sm text-brand-grey">Trees Planted</p>
    </div>
  );
}
